import React, { useLayoutEffect, useEffect, useRef, useState } from 'react';
import { select } from 'd3';
import * as d3 from 'd3';
import './style.css';

const VerticalBarChart = (props) => {
  const alphabet = props.data;
  const chartID = props?.id;
  const [horizontalBarWidth, setHorizontalBarWidth] = useState(0);
  const [yAxisTitle, setYAxisTitle] = useState("");

  const chartRef = useRef(null);
  const ref = useRef(null);
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight
  });
  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight
    })
  }
  const maindata = alphabet[0]?.values;
  const data = maindata.sort((a, b) => new Date(a.key) - new Date(b.key));

  useEffect(() => {
    window.addEventListener('resize', setDimension);
    
    return(() => {
      window.removeEventListener('resize', setDimension);
    })
  }, [screenSize])

  useEffect(() => {
    setYAxisTitle(alphabet[0]?.name)
  },[alphabet]);
  
  useLayoutEffect(() => {
    setHorizontalBarWidth(ref.current.offsetWidth);
  }, [screenSize]);
  
  useEffect(() => {
    setTimeout(()=> {
      d3.select(chartRef.current).select('svg').remove();
      const width = horizontalBarWidth || ref?.current?.offsetWidth;
      const height = 320;
      const marginTop = 20;
      const marginRight = 20;
      const marginBottom = 30;
      const marginLeft = 50;
      const horizontalWidth = width - marginLeft - marginRight;
      const horizontalheight = height - marginLeft - marginRight;  
  
      // Declare the x (horizontal position) scale.
      const x = d3
        .scaleBand()
        .domain(data.map(d => d.key))
        .range([marginLeft, width - marginRight])
        .padding(0.1);
  
      // Declare the y (vertical position) scale.
      const y = d3
        .scaleLinear()
        .domain([0, d3.max(data, (d) => d.value)])
        .range([height - marginBottom, marginTop]);
  
      // Create the SVG container.
      const svg = select(chartRef.current)
        .append('svg')
        .attr('class', "barChart")
        .attr('width', width)
        .attr('height', height)
        .attr('viewBox', [0, 0, width, height])
        .attr('style', 'max-width: 100%; height: auto;')
        .on('mouseover', (d, i) => {
          svg.selectAll('.horizontal-react-bar-div').style('opacity', '.5');
        })
        .on('mouseout', (d, i) => {
          svg.selectAll('.horizontal-react-bar-div').style('opacity', '1');
        });
  
      // Add a rect for each bar.
      svg
        .append('g')
        .attr('fill', '#878787')
        .selectAll()
        .data(data)
        .join('rect')
        .attr('x', (d) => x(d.key))
        .attr('y', (d) => y(d.value))
        .attr('class', 'horizontal-react-bar-div')
        .attr('id', (d, i) => 'horizontalreactbar' + chartID + i)
        .attr('data-id', (d, i) => i)
        .attr('height', (d) => y(0) - y(d.value))
        .attr('width', 6)
        .attr('cursor', 'pointer')
        .on('mouseover', function (d, i) {
          const barUpperText = '#bartextupper' + chartID + d.target.dataset.id;
          const barLowerText = '#bartextlower' + chartID + d.target.dataset.id;
          d3.select(this).classed('active', true);
          d3.select(barUpperText).classed('active', true);
          d3.select(barLowerText).classed('active', true);
        })
        .on('mouseout', function (d, i) {
          const barUpperText = '#bartextupper' + chartID + d.target.dataset.id;
          const barLowerText = '#bartextlower' + chartID + d.target.dataset.id;
          d3.select(this).classed('active', false);
          d3.select(barUpperText).classed('active', false);
          d3.select(barLowerText).classed('active', false);
        });
      svg
        .append('g')
        .attr('fill', 'transparent')
        .selectAll()
        .data(data)
        .join('rect')
        .attr('text-anchor', 'middle')
        .attr('x', (d) => x(d.key))
        .attr('y', 40)
        .attr('class', 'horizontal-react-bar-div')
        .attr('data-id', (d, i) => i)
        .attr('height', horizontalheight)
        .attr('width', 12)
        .attr('cursor', 'pointer')
        .on('mouseover', function (d, i) {
          const bar = '#horizontalreactbar' + chartID + d.target.dataset.id;
          const barUpperText = '#bartextupper' + chartID + d.target.dataset.id;
          const barLowerText = '#bartextlower' + chartID + d.target.dataset.id;
          d3.select(bar).classed('active', true);
          d3.select(barUpperText).style('display', "block");
          d3.select(barLowerText).style('display', "block");
          d3.select(barUpperText).classed('active', true);
          d3.select(barLowerText).classed('active', true);
        })
        .on('mouseout', function (d, i) {
          const bar = '#horizontalreactbar' + chartID + d.target.dataset.id;
          const barUpperText = '#bartextupper' + chartID + d.target.dataset.id;
          const barLowerText = '#bartextlower' + chartID + d.target.dataset.id;
          d3.select(barUpperText).style('display', "none");
          d3.select(barLowerText).style('display', "none");
          d3.select(bar).classed('active', false);
          d3.select(barUpperText).classed('active', false);
          d3.select(barLowerText).classed('active', false);
        });
      
      // add label top of the bar
      svg
      .selectAll('.bar-text')
      .data(data)
      .join('text')
      .attr('class', "bar-text")
      .attr('text-anchor', 'middle')
      .attr('font-family', '"Ericsson Hilda",Helvetica,sans-serif')
      .attr('font-size', '14px')
      .attr('opacity', '0')
      .attr('display', 'none')
      .attr('x', (d) => x(d.key))
      .attr('y', (d) => y(d.value) - 5)
      .attr('id', (d, i) => 'bartextupper' + chartID + i)
      .text((d) => d.value);
      
      // add label bottom of the bar
      svg
      .selectAll('.bar-text-lower')
        .data(data)
        .join('text')
        .attr('class', "bar-text-lower")
        .attr('text-anchor', 'middle')
        .attr('font-family', '"Ericsson Hilda",Helvetica,sans-serif')
        .attr('font-size', '14px')
        .attr('display', 'none')
        .attr('opacity', '0')
        .attr('x', (d) => x(d.key))
        .attr('y', (d) => y(0) + 18)
        .attr('id', (d, i) => 'bartextlower' + chartID + i)
        .text((d) => d.key);
      // Add the x-axis and label.

      svg
      .append('text')
      .attr('x', width - 33)
      .attr('y', 318)
      .text(yAxisTitle || 'Count');

      svg
        .append('g')
        .attr('transform', `translate(0,${height - marginBottom})`)
        .call(d3.axisBottom(x).tickSizeOuter(1))
        .call((g) => g.selectAll('.tick Line, .tick Text').remove());;
  
      // Add the y-axis and label, and remove the domain line.
      svg
        .append('g')
        .attr('transform', `translate(${marginLeft},0)`)
        .attr('stroke-dasharray', '2')
        .call(d3.axisLeft(y).tickSizeOuter(1).tickSize(-horizontalWidth).tickFormat((y) => y).ticks(3))
        .call((g) => g.select('.domain').remove());
    }, 100);
  }, [data, screenSize]);

  return (
      <div ref={ref}>
        <div ref={chartRef}></div>
      </div>
  );
};

export default VerticalBarChart;
